<template>
  <article
    class="article-lead article outer"
    v-if="context.item.templatename != 'msstartseite' && context.item.ueberschrift"
  >
    <div class="container">
      <header class="lead-img" v-if="context.item.bild.url">
        <div class="lead-img__media color-overlay">
          <img
            id="imgBild"
            class="lead-img__img"
            :src="getField(`bild`).url"
            :alt="getField(`bild`).alt"
          />
          <h1 class="lead-img__title">
            <span class="headline" v-html="context.item.ueberschrift"></span>
          </h1>
        </div>
      </header>

      <header class="lead-header" v-else>
        <h1 class="lead-header__title">
          <span class="headline" v-html="context.item.ueberschrift"></span>
        </h1>
      </header>

      <div class="article__text" v-html="context.item.text"></div>
    </div>
  </article>
</template>

<script>
export default {
  name: 'Aufmacher',
  props: {
    context: {
      type: Object,
    },
  },

  methods: {
    getField(field) {
      const fullPath = `${field}`;
      return this.context.item[fullPath] || '';
    },
  },
};
</script>
